import { PageContext } from 'vike/types';
import { useRootStore } from '@/stores/root';
import { useConnectionStore } from '@/stores/connection';

export const initConnectionStore = (pageContext: PageContext) => {
  const rootStore = useRootStore();
  const connectionStore = useConnectionStore();

  if (pageContext.urlParsed.search.__SERVER_ADDRESS) {
    rootStore.setApiBase(pageContext.urlParsed.search.__SERVER_ADDRESS);
  }

  connectionStore.init({ apiBase: rootStore.apiBase });
};
